import React from "react"
import SocialIcon from "../social-icon"
import IconButtonBase from "./icon-button-base"
import type { IconButtonBaseProps } from "./icon-button-base"

export type SocialIconButtonProps = {
  /** Social icon name (e.g. "linkedin-in", "x-twitter") */
  icon: string
} & Omit<IconButtonBaseProps, "children">

const SocialIconButton = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  SocialIconButtonProps
>(({ icon, ...props }, ref) => {
  return (
    <IconButtonBase {...props} ref={ref}>
      <SocialIcon name={icon} className="pointer-events-none" />
    </IconButtonBase>
  )
})

export default SocialIconButton
